import { SnackbarService } from './../shared/services/snackbar.service';
import { ComboboxItem } from './model/combobox-item.model';
import { PortfolioItem } from './model/portfolio-item.model';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import {
  AddOccurenceModalComponent
} from './add-occurence-modal/add-occurence-modal.component';
import {
  MatDialogRef,
  MatDialog,
  MatDialogConfig,
  MatTableDataSource,
  MatPaginator,
  MatSort,
  MatDatepickerInputEvent,
  MatInput,
  MatSelect,
} from '@angular/material';
import { OccurencesService } from './occurences.service';
import {
  OccurrencePaginationParameters
} from './model/occurrence-pagination-parameters.model';
import { AuthService } from '../core/auth/auth.service';
import { AuthUser } from '../core/auth/auth-frame/auth-user.model';
import { Observable } from 'rxjs';
import { Occurence } from './model/occurence.model';
import { Sort, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { OcurrenceDemanda } from './interface/ocurrence-demanda';
import { CONSTANTS } from '@app/shared/constants';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormGroup, FormBuilder, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { OccurenceType } from './model/occurence-type.model';
import { UtilService } from '@app/shared/utils';
import { AppDateAdapter, APP_DATE_FORMATS } from './add-occurence-modal/occurence-dates/date-adapter';
import { OcurrencesDemandaTable } from './interface/ocurrences-demanda.table';
import { Spreadsheet } from '@app/shared/export/spreadsheet';
import { differenceInCalendarDays } from 'date-fns';
import { idMask } from '@app/shares/services/text-mask/text-mask';

const namePage = 'cadastro/cadastroDemanda';

@Component({
  selector: 'app-occurences',
  templateUrl: './occurences.component.html',
  styleUrls: ['./occurences.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    {
      provide: DateAdapter, useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})

export class OccurencesComponent implements OnInit {
  occurrencePaginationParameters: OccurrencePaginationParameters;
  private authUser: AuthUser;
  private closedModel: boolean = false;
  authSubject: Observable<AuthUser>;
  isVisualization: boolean = false;
  errorDownloadFile: boolean = false;
  infoDisabledNotification: string = CONSTANTS.INFO_DISABLE_NOTIFICAION;
  occurrenceTooltip = new MatTableDataSource();

  statusCombo: ComboboxItem[];
  typesCombo: ComboboxItem[];
  portfoliosCombo: PortfolioItem[];

  displayedColumns: string[] = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status', 'visualizar'];
  filterForm: FormGroup;
  dataSource = new MatTableDataSource();

  dialogRef: MatDialogRef<AddOccurenceModalComponent>;
  pageSizeOptions: number[] = [10, 20, 30];
  pageIndex: number;
  public currentPage = 0;

  pageSize: number = this.pageSizeOptions[0];
  occurrenceListIsEmpty: boolean;
  occurrenceListFilterIsEmpty: boolean;
  appliedFilter: boolean;
  showGrid : boolean;

  canLoadFilters: boolean = true;
  styleChanged: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  expandedElement: any;
  displayedColumnsExpandable: string[] = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status'];
  dataSourceExpandedItem = new MatTableDataSource();

  @Input() showLoading: Boolean = false;

  minDate: Date = new Date(1970, 1, 1);
  public idMask = idMask

  @ViewChild('pickerStartDate', {
    read: MatInput
  }) pickerStartDate: MatInput;

  @ViewChild('pickerEndDate', {
    read: MatInput
  }) pickerEndDate: MatInput;

  @ViewChild('ocurrenceSelectDate') public ocurrenceSelectDate: MatSelect;

  public isMobile = false;

  constructor(
    private dialog: MatDialog,
    private occurrencesService: OccurencesService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    private cdref: ChangeDetectorRef,
    private utils: UtilService
  ) {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 760;
    this.buildFilterForm();
    this.searchOccurrence();
    this.clearFilter();
  }

  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.maxWidth = '90%';
    dialogConfig.width = '90%';
    dialogConfig.maxHeight = '95%';
    dialogConfig.panelClass = 'occurrence-dialog';
    dialogConfig.height = '95%';
    this.dialogRef = this.dialog.open(AddOccurenceModalComponent, dialogConfig);
    this.dialogRef.afterClosed().subscribe(() => {
      this.searchOccurrence();
    });
  }

  public handlePage(e: any) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.searchOccurrence();
  }

  public sortOccurrence(sortCol: Sort) {
    this.searchOccurrence();
    this.sort.active = sortCol.active;
    this.sort.direction = sortCol.direction;
  }

  getOccurrenceParameters(): OccurrencePaginationParameters {
    let cpfCnpj = this.filterForm.get('fCpfCnpj').value;
    if (cpfCnpj == '') {
      cpfCnpj = null;
    }
    let fCode = this.filterForm.get('fCode').value;
    if (fCode == '') {
      fCode = null;
    }
    let occurrenceIdNumberValue: number = null;
    let occurrenceIdStringValue = this.filterForm.get('occurrenceId').value;
    if (occurrenceIdStringValue && occurrenceIdStringValue != '') {
      occurrenceIdNumberValue = Number(occurrenceIdStringValue);
    }

    const occurrencePaginationParameters: OccurrencePaginationParameters = {
      userName: this.authUser.gestor,
      pageIndex: this.currentPage,
      pageSize: this.pageSize,
      sortColumn: this.getActiveSortColumn(this.sort),
      sortOrder: this.getDirectionSort(),
      occurrenceFilterDate: this.filterForm.get('occurrenceFilterDate').value,
      startDate: this.filterForm.get('startDate').value,
      endDate: this.filterForm.get('endDate').value,
      occurrenceId: (occurrenceIdNumberValue == null || isNaN(occurrenceIdNumberValue) || (occurrenceIdNumberValue > Number.MAX_SAFE_INTEGER)) ? null : occurrenceIdNumberValue,
      types: this.filterForm.get('types').value,
      status: this.filterForm.get('status').value,
      fCode: fCode,
      fCpfCnpj: cpfCnpj ? cpfCnpj.replace(/[^\d]+/g, '') : cpfCnpj
    };
    return occurrencePaginationParameters;
  }

  getActiveSortColumn(sort: Sort) {
    if (sort) {
      if (sort.active === 'status') {
        return 'STATUS_NAME';
      } else if (sort.active === 'database') {
        return 'CREATION_DATE_TIME'
      } else if (sort.active === 'unreadCommentNotification') {
        return 'UNREAD_COMMENT_NOTIFICATION';
      }
    } else {
      return 'UNREAD_COMMENT_NOTIFICATION';
    }
  }

  getDirectionSort() {
    if (this.sort) {
      if (this.sort.direction.trim() !== '') {
        return this.sort.direction.toUpperCase().toString();
      } else {
        return this.sort.start.toUpperCase().toString();
      }
    } else {
      return 'DESC'.toString();
    }
  }

  viewOccurrence(occurrence: Occurence): void {
    if (!this.closedModel) {
      this.closedModel = true;
      this.occurrencesService.getOcurrenceById(occurrence.id).subscribe(
        occurrenceResponse => {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = true;
          dialogConfig.maxWidth = '90%';
          dialogConfig.width = '90%';
          dialogConfig.maxHeight = '95%';
          dialogConfig.height = '95%';
          dialogConfig.panelClass = 'occurrence-dialog';
          dialogConfig.data = occurrenceResponse;

          this.occurrencesService.getHasCommentsByOcurrenceById(occurrence.id).subscribe(result => {
            this.occurrencesService.currentGestorDemanda = occurrence.userName;
            occurrenceResponse.hasComments = result;
            this.showModal(dialogConfig);
          });
        }, error => {
          //- Threat Error
        }
      );
    }
  }

  clearFilter(): void {
    this.appliedFilter = false;
    this.pageSize = this.pageSizeOptions[0];
    this.filterForm.reset();

    if(this.paginator)
      this.paginator.pageSize = 0

    this.searchOccurrence(true);
    if (this.isMobile) {
      this.filterForm.get('startDate').enable();
      this.filterForm.get('endDate').enable();
    } else {
      this.filterForm.get('startDate').disable();
      this.filterForm.get('endDate').disable();
    }
  }

  showModal(matDialogConfig: MatDialogConfig): void {
    this.dialogRef = this.dialog.open(AddOccurenceModalComponent, matDialogConfig);
    this.dialogRef.afterClosed().subscribe(result => {
      this.searchOccurrence();
      this.closedModel = false;
    });
  }

  cpfCnpjValidator(control: FormControl) {
    if (control.value) {
      if (control.value !== '' && !OccurencesService.cpfCnpjValidator(control.value)) {
        return { 'cpfCnpjValidator': true };
      }
    }
    return null;
  }

  getDisplayedColumns(showColumnManager: boolean): void {
    this.displayedColumns = Array[''];
    if (showColumnManager) {
      this.displayedColumns = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'gestor', 'status', 'visualizar'];
    } else {
      this.displayedColumns = ['id', 'database', 'dataevento', 'tipo', 'nome', 'cpfcnpj', 'status', 'visualizar']
    }
  }

  listOccurrencesByParameters(occurrencePaginationParameters: OccurrencePaginationParameters): void {
    this.showLoading = true;
    this.occurrenceListIsEmpty = false;
    this.occurrenceListFilterIsEmpty = false;
    this.showGrid = true;

    if (occurrencePaginationParameters) {
      this.occurrencesService.getOccurenceListPost(occurrencePaginationParameters).subscribe(
        occurrenceResponse => {

          if (occurrenceResponse) {
            this.dataSource = new MatTableDataSource(occurrenceResponse['content'] as OcurrenceDemanda[]);
            if (this.dataSource.data.length <= 0) {
              this.showGrid = false;

              if (this.appliedFilter) {
                this.occurrenceListFilterIsEmpty = true;
              } else {
                this.occurrenceListIsEmpty = true;
              }
            } else {
              this.getDisplayedColumns(this.dataSource.data["0"].userName);
            }
            if (this.paginator) {
              this.paginator.length = occurrenceResponse['totalElements'] as number;
            }
          } else {
            this.dataSource = new MatTableDataSource();
            this.showGrid = false;
          }
          this.showLoading = false;
        }, () => { this.showLoading = false; }
      );
    }
  }

  buildFilterForm(): void {
    this.filterForm = this.formBuilder.group(
      {
        occurrenceFilterDate: [''],
        startDate: [{value: '', disabled: true }],
        endDate: [
          {value: '', disabled: true },
          [this.validatorEndDateLess.bind(this), this.validatorComparationDate.bind(this)]],
        occurrenceId: [null],
        types: [''],
        status: [''],
        fCode: [''],
        fCpfCnpj: [null, [this.cpfCnpjValidator]],
      },
      { validators: [ startEndValidator, emptyStartDateValidator ] }
    );
    if (this.isMobile) {
      this.filterForm.get('startDate').enable();
      this.filterForm.get('endDate').enable();
    }
  }

  get startDate() { return this.filterForm.get('startDate'); }

  get endDate() { return this.filterForm.get('endDate'); }

  updateFormControl(formControlName: string, event: MatDatepickerInputEvent<Date>) {
    this.filterForm.get(formControlName).setValue(event.value);
  }

  loadFilters() {
    if (this.canLoadFilters) {
      this.loadStatusCombobox();
      this.loadTypesCombobox();
      this.canLoadFilters = false;
    }
  }

  loadTypesCombobox(): void {
    this.showLoading = true;
    this.occurrencesService.getOccurenceTypes().subscribe(
      (response: OccurenceType[]) => {
        this.typesCombo = response;
        this.showLoading = false;
      },
      err => this.handleError('Não foi possível carregar os tipos de demandas.'),
      () => { this.showLoading = false; }
    );
  }

  loadStatusCombobox(): void {
    this.occurrencesService.getStatus().subscribe(
      (response: ComboboxItem[]) => {
        this.statusCombo = response;
      },
      err => this.handleError('Não foi possível carregar os status de demandas.')
    );
  }

  //Deprecated
  loadPortfoliosCombobox(): void {
    this.occurrencesService.getPortfolios().subscribe(
      (response: PortfolioItem[]) => {
        this.portfoliosCombo = response;
      },
      err => this.handleError('Não foi possível buscar os fundos de carteiras.')
    );
  }

  validatorEndDateLess(control: FormControl) {
    if (control && control.value) {
      if (this.filterForm.controls['startDate'].value) {
        if (control.value < this.filterForm.controls['startDate'].value) {
          return { notValid: true }
        }
      } else {
        return { notValid: true }
      }
    }
    return null;
  }

  validatorComparationDate() {
    const result = differenceInCalendarDays(
      new Date(this.filterForm.controls['endDate'].value),
      new Date(this.filterForm.controls['startDate'].value)
    );
    if (result > 60) {
      return { notComparation: true };
    }
    return null;
  }

  isEntityNullable(value: any): boolean {
    return value ? true : false;
  }

  submitEvent(category: string, action: string, label: string) {
  }

  handleError(message: string): void {
    this.snackbarService.showSnackbar(message, CONSTANTS.GLOBAL.OK.toUpperCase());
  }

  applyFilter() {
    this.appliedFilter = true;

    if (!this.filterForm.valid) {
      if (this.filterForm.hasError('emptyStartDate')) {
        this.handleError('A data inicial não pode ser vazia.');
      } else if (this.filterForm.hasError('startEndInvalid')) {
        this.handleError('A data inicial não pode ser maior que a data final.');
      } else {
        this.handleError('O filtro possui campos inválidos.');
      }
    } else {
      this.searchOccurrence(true);
    }
  }

  searchOccurrence(pageIndex?: any): void {
    const parameters = this.getOccurrenceParameters();
    if (pageIndex) {
      parameters.pageIndex = 0;
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
    }
    if (!Array.isArray(parameters.types)) {
      parameters.types = [];
    }
    if (!Array.isArray(parameters.status)) {
      parameters.status = [];
    }
    this.listOccurrencesByParameters(parameters);
  }


  async setStyleExpandeElems(): Promise<any> {
    return new Promise<void>((res) => {
      const allColumnsId = document.getElementsByClassName('cdk-column-id') as HTMLCollectionOf<HTMLElement>;;
      const elemIdReference = allColumnsId[0];
      const elemExpanded = document.getElementById('custom-style-id');

      if (elemIdReference && elemExpanded) {
        for (let i = 1; i < allColumnsId.length; i++) {
          const columId = allColumnsId[i];
          columId.style.padding = '0px';
          columId.style.width = `${elemIdReference.offsetWidth}px`;
          columId.style.height = `${elemIdReference.offsetHeight}px`;
        }
        res();
      }
    });
  }

  async seeMoreTypes(element) {
    await this.showExpandedItens(element);
    // this.setStyleExpandeElems();
  }

  showExpandedItens(element) {
    if (this.expandedElement && this.expandedElement === element) {
      this.expandedElement = null;
    } else {
      const lenTypes = element.occurrenceTypeName.length;
      const clonedOccurrenceTypes = [];

      for (let i = 0; i < lenTypes; i++) {
        clonedOccurrenceTypes.push(
          {
            cnpjCpf: element.cnpjCpf,
            creationDateTime: element.creationDateTime,
            description: element.description,
            fundName: element.fundName,
            id: element.id,
            occurrenceTypeName: element.occurrenceTypeName[i],
            statusName: element.statusName,
            userName: element.userName
          });
      }

      this.dataSourceExpandedItem = new MatTableDataSource(clonedOccurrenceTypes as OcurrenceDemanda[]);
      this.expandedElement = element;
    }
  }

  public exportSpreadsheet (): void {
    this.showLoading = true;
    const rowLimit = 500;
    const pagination = this.getOccurrenceParameters();
    pagination.pageIndex = 0;
    pagination.pageSize = rowLimit;
    pagination.types = pagination.types || [];
    pagination.status = pagination.status || [];
    this.occurrencesService.getOccurenceListPost(pagination)
      .subscribe((response: {content: Array<OcurrenceDemanda>}) => {
        const tableToExport = this.convertToSpreadsheet(response.content);
        if (tableToExport.length >= rowLimit) {
          this.showLimitToExportMessage(rowLimit);
        }
        const spreadsheetGenerator = new Spreadsheet<OcurrencesDemandaTable>('demandas', tableToExport);
        spreadsheetGenerator.generateSpreadsheet();
        this.showLoading = false;
      }, () => this.showLoading = false);
  }

  private convertToSpreadsheet(table: Array<OcurrenceDemanda>): Array<OcurrencesDemandaTable> {
    return table.map((ocurrence: OcurrenceDemanda) => ({
      'id': ocurrence.id,
      'data solicitação': ocurrence.creationDateTime,
      'data evento': ocurrence.eventDate,
      'tipo': ocurrence.occurrenceTypeName,
      'nome': ocurrence.fundName,
      'CPF/CNPJ': ocurrence.cnpjCpf,
      'status': ocurrence.statusName,
    }));
  }

  private showLimitToExportMessage(limit: number): void {
    this.handleError(this.messageExportLimit(limit));
  }

  public messageExportLimit(limit: number) {
    return `O limite para a exportação é de ${limit} registros,`
    + ` apenas os primeiros ${limit} serão exibidos, você pode refazer a busca para`
    + ' exportar todas as demandas que necessita visualizar.';
  }

  occurrenceDateOptions: any[] = [
    { value: "dateRequest", viewValue: "Data da Solicitação" },
    { value: "dateEvent", viewValue: "Data do Evento" }
  ]

  onSelectionChange({value}) {
    if (value === 'dateRequest' || value === 'dateEvent') {
      this.filterForm.get('startDate').enable();
      this.filterForm.get('endDate').enable();
    }
  }

  public emptyFilter(): boolean {
    const emptyDates = !this.getField('startDate') && !this.getField('endDate');
    const empyDropdowns = !this.getField('types')
      && !this.getField('status')
      && !this.getField('fCode');

    return emptyDates
      && empyDropdowns
      && !this.getField('occurrenceId')
      && !this.getField('fCpfCnpj');
  }

  private getField(field: string): any {
    return this.filterForm.controls[field].value;
  }

  handlePermissionComment(userName: string): boolean {
    return true; // TODO: regra será revisada
  }

  handleNullOrUndefined(element: any): any {
    return this.utils.handleNullOrUndefined(element);
  }
};

export const startEndValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const startDate = control.get('startDate');
  const endDate = control.get('endDate');

  return startDate && startDate.value && endDate && endDate.value && startDate.value > endDate.value ? { 'startEndInvalid': true } : null;
};

export const emptyStartDateValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const startDate = control.get('startDate');
  const endDate = control.get('endDate');

  return (!startDate || !startDate.value) && endDate && endDate.value ? { 'emptyStartDate': true } : null;

};
